export default __webpack_public_path__ + "static/apec-challenge-bbc4b1aa311216c0398953bcc10f666e.jpg";